import React from "react";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getTokenAsync } from "../../utils/tokenManage";

function SearchFilter({
                          key,
                          serviceGroup,
                          startDate,
                          endDate,
                          onServiceGroupChange,
                          onStartDateChange,
                          onEndDateChange
                      }) {
    const [selectedRange, setSelectedRange] = useState("today");
    const [serviceGroupOptions, setServiceGroupOptions] = useState([]);

    const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
        <input
            ref={ref}
            value={value || ""}
            onClick={onClick}
            readOnly
            className="date-form form-control"
        />
    ));

    useEffect(() => {
        getOprSelect();
    }, [serviceGroup]);

    const getOprSelect = async () => {
        const authToken = await getTokenAsync();

        try {
            const url = `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/token/menu/oprmng?menuval=counselnotice&serviceType=S`;

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": authToken
                }
            });

            if (!response.ok) {
                throw new Error("서비스 그룹 조회 실패");
            }

            const data = await response.json();

            const source = Array.isArray(data) ? data : [];

            const options = source.map((item) => ({
                value: item.serviceGroup,
                label: item.serviceGroupName,
                custCode: item.custCode
            }));

            setServiceGroupOptions(options);

            const exists = options.some((item) => item.value === serviceGroup);

            if (!exists && options.length > 0) {
                onServiceGroupChange(options[0].value);
            }

        } catch (error) {
            console.error("서비스 그룹 조회 에러:", error);
            setServiceGroupOptions([]);
        }
    };

    const setTodayRange = () => {
        const today = new Date();
        onStartDateChange(today);
        onEndDateChange(today);
        setSelectedRange("today");
    };

    const setWeekRange = () => {
        const today = new Date();
        const weekAgo = new Date();
        weekAgo.setDate(today.getDate() - 6);

        onStartDateChange(weekAgo);
        onEndDateChange(today);
        setSelectedRange("week");
    };

    return (
        <div className="filter-row">
            <div className="filter-label">호텔명</div>

            <div className="filter-field">
                <select
                    className="form-select"
                    value={serviceGroup}
                    onChange={(e) => onServiceGroupChange(e.target.value)}
                >
                    {serviceGroupOptions.map((item, idx) => (
                        <option key={idx} value={item.value}>
                            {item.label}
                        </option>
                    ))}
                </select>
            </div>

            <div className="filter-label date-select">
                <p>등록일자</p>

                <div className="filter-date-actions">
                    <button
                        type="button"
                        className={`pill ${selectedRange === "today" ? "active" : ""}`}
                        onClick={setTodayRange}
                    >
                        오늘
                    </button>

                    <button
                        type="button"
                        className={`pill ${selectedRange === "week" ? "active" : ""}`}
                        onClick={setWeekRange}
                    >
                        일주일
                    </button>
                </div>
            </div>

            <div className="filter-field filter-date">
                <div className="filter-date-range">
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => {
                            onStartDateChange(date);
                            setSelectedRange("");
                        }}
                        dateFormat="yyyy-MM-dd"
                        className="date-form form-control"
                        popperPlacement="bottom-start"
                        inputMode="none"
                        customInput={<CustomDateInput />}
                    />

                    <span className="tilde">~</span>

                    <DatePicker
                        selected={endDate}
                        onChange={(date) => {
                            onEndDateChange(date);
                            setSelectedRange("");
                        }}
                        dateFormat="yyyy-MM-dd"
                        className="date-form form-control"
                        popperPlacement="bottom-start"
                        inputMode="none"
                        customInput={<CustomDateInput />}
                    />
                </div>
            </div>
        </div>
    );
}

export default SearchFilter;